import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";
import {
    TicketsTopicsParams,
    TicketsTopicsStatsResponse,
} from "interfaces/entities/ticketStats";

export const useTicketsTopicsStats = (
    params: TicketsTopicsParams = {}
) => {
    // orgID попадает в queryKey, чтобы кэш корректно разделялся между организациями
    const orgID = localStorage.getItem("orgID") || "";

    return useQuery<TicketsTopicsStatsResponse>({
        queryKey: ["tickets-topics-stats", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getTicketsTopicsStats(params);
            return response.data;
        },
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
